import Vue from 'vue';
import { ActionTree, MutationTree, GetterTree } from 'vuex';
import { RootState } from '@/store/types';
import { ServerResult } from '@/core/http/server_result';
import moment from 'moment';

interface WorkPlanBoardState {
    loaded: boolean;
    loading: boolean;
    fatalError: boolean;

    events: any[];

    // items: any[];
}

const state: WorkPlanBoardState = {
    loading: false,
    loaded: false,
    fatalError: false,

    events: [],

    // items: [],
};

export const LOAD_CALENDAR_EVENT_LIST = 'LOAD_CALENDAR_EVENT_LIST';

export const actions: ActionTree<WorkPlanBoardState, RootState> = {
    loadFilterData({ commit, getters, dispatch, rootState }) {
        const vm = (this as any)._vm;

        return new Promise((resolve, reject) => {
            commit('START_LOADING');
            vm.$db([
                vm.$q(LOAD_CALENDAR_EVENT_LIST)
                .select()
                .from('calendar_events')
                .fileds$((_: any) => {
                  return {
                    id: 'calendar_events.id',
                    calendar_id: 'calendar_events.calendar_id',
                    related_entity_id: 'calendar_events.related_entity_id',
                    datetime: 'calendar_events.datetime',
                    name: 'calendar_events.name',
                    description: 'calendar_events.description',
                    created_at: 'calendar_events.created_at',
                  };
                })
                .where((_: any) => _.eq('calendar_events.owner_id', _.const((rootState as any).ubic.actor.document.id)))
                .order((_: any) =>
                  ([_.desc(['calendar_events.datetime'])])
                ),
            ]).then(((result: ServerResult) => {
                commit('SET_EVENT_LIST', result.getOperation(LOAD_CALENDAR_EVENT_LIST).getContent());
                commit('LOADED_SUCCESS');

                resolve();
            }));
        })
    },

    loadData({ commit, getters, dispatch }) {
        const vm = (this as any)._vm;

        dispatch('loadFilterData')
            .then(() => {
                console.log('1')
            });
    },

};

export const mutations: MutationTree<WorkPlanBoardState> = {
    START_LOADING: (state) => {
        state.loaded = false;
        state.fatalError = false;
    },
    LOADED_SUCCESS: (state) => {
        state.loaded = true;
        state.fatalError = false;
    },
    LOADED_ERROR: (state) => {
        state.loaded = true;
        state.fatalError = true;
    },

    SET_EVENT_LIST(state, data) {
        console.log('data.documents', data.documents)
        // calendar_id: "d:calendars:2"
        // created_at: "2020-04-09T09:00:01.018689"
        // datetime: "2020-04-09T02:00:01.020530"
        // description: null
        // id: "d:calendar_events:207"
        // name: "У клиента Первый должна быть сформирована заявка к 09.04.2020."
        // related_entity_id: null

        // {
        //     title  : 'event1',
        //     start  : '2010-01-01'
        //   },
        state.events = data.documents;
    },
};

const getters: GetterTree<WorkPlanBoardState, RootState> = {
    eventSources: (state: WorkPlanBoardState) => {
        return state.events.map((event: any) => {
            return {
                title: event.name,
                description: event.name,
                start: event.datetime,
                allDay: true,
                isFirstMonthPart: moment(event.datetime).day() < 16,
                extendedProps: {
                    ...event
                }
            }
        });
    },
};


export const STORE_KEY = '$_calendar';

export const store = {
    namespaced: true,
    state,
    actions,
    getters,
    mutations,
};
